import React, { FC } from "react";

import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import FieldType from "@mapmycustomers/shared/enum/fieldModel/FieldType";
import PinLegendDatingMethod from "@mapmycustomers/shared/enum/pinLegends/PinLegendDatingMethod";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import { Breakpoints } from "@mapmycustomers/shared/types/map/PinLegend";

import DateBreakpoints from "./DateBreakpoints";
import NumericBreakpoints from "./NumericBreakpoints";

export interface BreakpointsFieldProps {
  breakpoints?: Breakpoints;
  datingMethod: PinLegendDatingMethod;
  field: IField;
  onChange?: (breakpoints: Breakpoints) => void;
  onError?: (hasError: boolean) => void;
}

const BreakpointsField: FC<BreakpointsFieldProps> = ({ breakpoints, field, ...props }) => {
  if (field.hasFeature(FieldFeature.NUMERIC)) {
    return <NumericBreakpoints breakpoints={breakpoints as number[]} {...props} />;
  } else if (field.type === FieldType.DATE || field.type === FieldType.DATE_TIME) {
    return <DateBreakpoints breakpoints={breakpoints} {...props} />;
  }

  return null;
};

export default BreakpointsField;
